import { useMemo, useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { couples } from "@/mocks/highlights";

export default function CouplesSection() {
  const [voted, setVoted] = useState<string | null>(null);

  const totalVotes = useMemo(
    () => couples.reduce((sum, c) => sum + c.vote, 0) + (voted ? 1 : 0),
    [voted]
  );

  return (
    <section id="couples" className="relative w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="荧幕CP盘点"
          title="哪一对，让你追到意难平"
          desc="荧幕情侣是追剧的一大乐子。这里列出本季讨论度最高的三对搭档，配上他们的经典台词。选一对你最喜欢的，看看大家的口味是否和你一致。"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {couples.map((cp) => {
            const isVoted = voted === cp.id;
            const votes = cp.vote + (isVoted ? 1 : 0);
            const pct = Math.round((votes / totalVotes) * 100);
            return (
              <article
                key={cp.id}
                className="reveal rounded-2xl border border-background-200 bg-background-50 overflow-hidden flex flex-col"
              >
                <div className="w-full h-48 overflow-hidden">
                  <img
                    src={cp.image}
                    alt={`《${cp.drama}》荧幕情侣 ${cp.pair}`}
                    title={`${cp.drama} 荧幕CP ${cp.actors}`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <span className="inline-flex items-center gap-1.5 text-xs text-primary-600 font-label mb-1.5">
                    <i className="ri-movie-2-line"></i>
                    《{cp.drama}》
                  </span>
                  <h3 className="font-heading font-semibold text-lg text-foreground-950">{cp.pair}</h3>
                  <p className="text-xs text-foreground-500 mt-1 font-label">{cp.actors}</p>

                  <p className="mt-3 text-sm italic text-foreground-600 leading-relaxed border-l-2 border-accent-400 pl-3">
                    {cp.line}
                  </p>

                  <span className="mt-3 inline-flex w-fit px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-[11px] font-label">
                    {cp.vibe}
                  </span>

                  <div className="mt-auto pt-4 border-t border-background-200">
                    <div className="flex items-center justify-between text-xs mb-2 font-label">
                      <span className="text-foreground-500">支持度</span>
                      <span className="text-foreground-800 font-medium">{pct}%</span>
                    </div>
                    <div className="h-2 rounded-full bg-background-200 overflow-hidden">
                      <div
                        className={`h-full rounded-full transition-all duration-500 ${
                          isVoted ? "bg-primary-500" : "bg-secondary-400"
                        }`}
                        style={{ width: `${pct}%` }}
                      ></div>
                    </div>
                    <button
                      type="button"
                      disabled={voted !== null}
                      onClick={() => setVoted(cp.id)}
                      className={`mt-4 w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md text-sm font-label transition-colors ${
                        voted === null
                          ? "bg-background-100 border border-background-300 text-foreground-800 hover:border-primary-300 hover:text-primary-600 cursor-pointer"
                          : isVoted
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-100 border border-background-200 text-foreground-400"
                      }`}
                    >
                      <i className={isVoted ? "ri-checkbox-circle-fill" : "ri-heart-add-line"}></i>
                      {voted === null ? "投 TA 一票" : isVoted ? "你已投了这一对" : "投票已结束"}
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}